import React from "react";

import { TreeItem } from "ui/Tree";

import { InferredIcon } from "fond/map/Legend";
import { LegendItemType } from "fond/map/Legend/Legend";
import { Label, Row } from "fond/map/Legend/Legend.styles";
import { Configuration } from "fond/types";
import { LayerConfig, LayerStyle, SublayerConfig } from "fond/types/ProjectLayerConfig";

interface IProps {
  config: Configuration;
  title: string;
  item: TreeItem<LegendItemType | null>;
}

const ItemTitle: React.FC<IProps> = ({ config, item, title }: IProps) => {
  const { data } = item;

  if (!data?.Type) return null;

  return (
    <Row className={`rct-tree-item-title-${data.Type}`} isVisible>
      {data.Type !== "GROUP" && data.Type !== "MapLayerConfig" && (
        <InferredIcon entity={data as LayerConfig | SublayerConfig | LayerStyle} config={config} />
      )}
      <Label entityType={data.Type} isVisible>
        {title}
      </Label>
    </Row>
  );
};

export default ItemTitle;
